import { render, staticRenderFns } from "./ykc-date-picker.vue?vue&type=template&id=035c1525"
import script from "./ykc-date-picker.vue?vue&type=script&lang=js"
export * from "./ykc-date-picker.vue?vue&type=script&lang=js"
import style0 from "./ykc-date-picker.vue?vue&type=style&index=0&id=035c1525&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports